import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function PaymentCancelPage() {
  usePageMeta("Payment Cancelled", "Your payment was cancelled.");
  return (
    <>
      <Header />
      <main className="min-h-screen flex items-center justify-center bg-black pt-24 pb-16">
        <div className="max-w-xl mx-auto px-6 text-center">
          <XCircle size={48} className="text-zinc-500 mx-auto mb-5" />
          <h1 className="font-display text-4xl text-white tracking-wide">Payment cancelled</h1>
          <p className="text-zinc-400 mt-3">No charge has been made. Pick up where you left off.</p>
          <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
            <Link to="/pricing" className="px-6 py-3 rounded-full bg-brand-yellow text-black font-black uppercase text-sm tracking-wider">Back to pricing</Link>
            <Link to="/contact" className="px-6 py-3 rounded-full border border-white/20 text-white font-bold uppercase text-sm tracking-wider hover:bg-white hover:text-black transition-all">Talk to us</Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
